import script from "./GastronomyDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyDetails.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyDetails.vue?vue&type=style&index=0&id=a7fec03a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7fec03a"]])

export default __exports__